import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { About } from "@/components/About";
import { Team } from "@/components/Team";
import { Services } from "@/components/Services";
import { Gallery } from "@/components/Gallery";
import { AppointmentForm } from "@/components/AppointmentForm";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";
import { FloatingWhatsApp } from "@/components/FloatingWhatsApp";
import { ChatWidget } from "@/components/ChatWidget";

export default function Home() {
  return (
    <div className="min-h-screen bg-background text-foreground" data-testid="home-page">
      <Navbar />
      <main>
        <Hero />
        <About />
        <Team />
        <Services />
        <Gallery />
        <AppointmentForm />
        <Contact />
      </main>
      <Footer />
      <FloatingWhatsApp />
      <ChatWidget />
    </div>
  );
}
